import React from "react";
import "./ImageSection.css";
import stud1 from "../../images/stud1.jpg";
import abc from "../../images/abc.jpg";

const ImageSection = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px",
      }}
    >
   <h1 style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
        <span style={{ borderBottom: "5px solid gold", padding: "3px", display: "inline-block" }}>
          Suffian's
        </span>
      </h1>
      <div
        className="is"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={stud1}
            alt="description"
            style={{ width: "90%", height: "85%" }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={abc}
            alt="description"
            style={{ width: "90%", height: "85%" }}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageSection;
